import React, { useState } from 'react';
// import { Document, Page } from 'react-pdf';
// import { Document, Page } from 'react-pdf';
import pdfFile from '../../Img/pdf.pdf'


// Create styles

function PdfViewer() {


 return (
  <center >

   <object data={pdfFile}
    width="1100"
    height="600">
   </object>
  </center>
 );

}

export default PdfViewer;
